import React from "react";

import { ScaleLoader } from "react-spinners";

function Spinner(props) {
  return (
    <>
      {/* {props.is_loading && (
        <div
          style={{
            width: "260px",
            height: "10px !important",
            margin: "auto",
            marginTop: props.top_margin + "px",
          }}
        >
          <div className="progress" style={{ width: "4% !important" }}>
            <div className="progress-bar progress-bar-indeterminate bg-green"></div>
          </div>
        </div>
      )} */}

      <div className="progress" style={{ width: "30%", margin: "auto" }}>
        <div className="progress-bar progress-bar-indeterminate bg-blue"></div>
      </div>
      {/* <div
        style={{
          width: "70px",
          height: "10px !important",
          margin: "auto",
          marginTop: props.top_margin + "px",
        }}
      >
        <ScaleLoader
          loading={props.is_loading === true}
          color="#0088D1"
          size={15}
        />
      </div> */}
    </>
  );
}

export default Spinner;
